/**
 * UAVTradeZone Modification Record
 *
 * Change ID:    TOAST_MSG_UPDATE_IRIT_2026
 * Date:         2026-01-27
 * Modified By:  Cursor
 *
 * Description:
 * Updated Toastify messages to Irit's improved user-friendly versions.
 *
 * Related Files: utils/notifications.ts
 */

/**
 * UAVTradeZone Modification Record
 *
 * Change ID:    SPLIT_COMPANY_PROFILE_CERTS
 * Date:         2025-12-29
 * Modified By:  Cursor
 *
 * Description:
 * Extracted certifications section from CompanyProfileForm.tsx.
 * Fixed incorrect relative import paths and implicit any types.
 *
 * Related Screens / Modules:
 * - client/src/components/setup/company-profile/components/Certifications.tsx
 */
import React, { useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faSpinner, faTimes } from "@fortawesome/free-solid-svg-icons";
import { resizeImages } from "../../../../utils/imageResizer";
import { notify } from "../../../../utils/notifications";

// [2025-12-29] Parameter type fix
export const Certifications: React.FC<{ formik: any }> = ({ formik }) => {
  const inputRef = useRef<HTMLInputElement | null>(null);
  const [isProcessing, setIsProcessing] = useState(false);

  const handleUpload = async (files: FileList | null) => {
    if (!files || files.length === 0) return;
    setIsProcessing(true);
    try {
      const resized = await resizeImages(Array.from(files), 500, 500, 0.8, 500);
      formik.setFieldValue("certifications", [...(formik.values.certifications || []), ...resized]);
    } catch (e) {
      // [2026-01-27] TOAST_MSG_UPDATE_IRIT_2026: Updated to user-friendly message
      notify.error(null, "We couldn't process the certifications. Please try again");
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <div className="mt-3">
      <div className="field-name mb-2">Upload Certification Logos</div>
      <div className="upload-grid mb-3">
        {formik.values.certifications?.map((img: any, idx: number) => (
          <div key={idx} className="upload-logo-square upload-logo-square-relative">
            <img alt="Cert" src={img.data.startsWith("data:") ? img.data : `data:${img.contentType};base64,${img.data}`} className="upload-logo-image" />
            <button type="button" onClick={() => {
              const next = [...formik.values.certifications];
              next.splice(idx, 1);
              formik.setFieldValue("certifications", next);
            }} className="upload-logo-remove-btn"><FontAwesomeIcon icon={faTimes} /></button>
          </div>
        ))}
        <div className="upload-logo-square" onClick={() => inputRef.current?.click()}>
          <FontAwesomeIcon icon={isProcessing ? faSpinner : faPlus} spin={isProcessing} />
        </div>
      </div>
      <input ref={inputRef} type="file" accept="image/*" multiple className="d-none" onChange={(e) => handleUpload(e.currentTarget.files)} />
    </div>
  );
};
